/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

AOS.init();

let swiper = new Swiper('.aboutSwiper', {
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: '.about-button-next',
    prevEl: '.about-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 4,
    },
  },
});

let eventSwiper = new Swiper('.eventSwiper', {
  navigation: {
    nextEl: '.event-button-next',
    prevEl: '.event-button-prev',
  },
  pagination: {
    el: '.event-pagination',
  },
  loop: true
});

let modalSwiper = new Swiper('.modalSwiper', {
  loop: true,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});
let modalSwiper2 = new Swiper('.modalLargeSwiper', {
  loop: true,
  navigation: {
    nextEl: '.modal-button-next',
    prevEl: '.modal-button-prev',
  },
  thumbs: {
    swiper: modalSwiper,
  },
});

let productSwiper = new Swiper('.productSwiper', {
  loop: true,
  slidesPerView: 3,
  freeMode: false,
  watchSlidesProgress: true,
  allowTouchMove: false,
});

let productSwiper2 = new Swiper('.productLargeSwiper', {
  loop: true,
  parallax: true,
  navigation: {
    nextEl: '.product-button-next',
    prevEl: '.product-button-prev',
  },
  thumbs: {
    swiper: productSwiper,
  },
});

const showEventCardButton = document.querySelector('.j-event__show');
const showEventCardList = document.querySelector('.j-event__card-list');

window.addEventListener('load', function () {
  showEventCardButton.addEventListener('click', function () {
    showEventCardList.classList.remove('hidden');
  });
});

// video
const videoEle = document.getElementById('video-ele');
const aboutSection = document.getElementById('about-section');

const option = {threshold: 0.5}

const intersectionObserver = new IntersectionObserver(entries => {
  if (entries[0].intersectionRatio <= 0) {
    return;
  }

  videoEle.pause();
  videoEle.muted = true;
}, option);

intersectionObserver.observe(aboutSection);

window.addEventListener('scroll', () => {

  // 關於主標加入文字動畫
  const aboutSection = document.querySelector('.j-about-section');
  const aboutTitle = document.querySelectorAll('.j-about-section h1 span');

  aboutTitle.forEach((element) => {

    if (aboutSection.getBoundingClientRect().top > 0) {
      element.classList.add('l-about__title--animate');
    }

    if (aboutSection.getBoundingClientRect().bottom < 0) {
      element.classList.remove('l-about__title--animate');
    }
  });

  // 葉子視差
  const scrollPositionY = window.scrollY;
  const leafs = document.querySelectorAll('.j-leafs');

  leafs.forEach((element) => {
    element.style.transform = `translateY(-${scrollPositionY / 10}px)`;
  });
}); 
